import { render, staticRenderFns } from "./ResetStage.vue?vue&type=template&id=2a69be00&scoped=true"
import script from "./ResetStage.vue?vue&type=script&lang=js"
export * from "./ResetStage.vue?vue&type=script&lang=js"
import style0 from "./ResetStage.vue?vue&type=style&index=0&id=2a69be00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a69be00",
  null
  
)

export default component.exports